import React from "react";
import { useSearchParams } from "react-router-dom";
import { EmptyList, Loading } from "../../../components";
import { parseSearchParams } from "../../../helpers/clean-object";
import { useLazySites } from "../hooks";
import { SiteCard } from "../components";

export const Sites = () => {
  const [searchParams] = useSearchParams();

  const [limit, setLimit] = React.useState(25);
  const [search, { data, loading, fetchMore, error }] = useLazySites();

  console.log({ data, loading, error });

  React.useEffect(() => {
    search({
      variables: {
        where: parseSearchParams(searchParams),
      },
    });
  }, [searchParams]);

  const renderList = () => {
    if (loading) return <Loading />;

    return data?.sites?.results?.length && data?.sites?.results?.length > 0 ? (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {data?.sites?.results?.map((site) => (
          <SiteCard
            key={site?.id}
            id={site?.id}
            name={site?.name}
            url={site?.url}
            productsCount={site?.productsCount}
          />
        ))}
      </div>
    ) : (
      <EmptyList text="Aucun Résultat" />
    );
  };

  if (loading) return <Loading />;

  return (
    <div className="main-container">
      {/* <SearchSiteInput {...parseSearchParams(searchParams)} /> */}

      <div className="mb-4">{renderList()}</div>

      {data?.sites?.hasMore && (
        <div className="flex justify-center">
          <button
            className="cursor-pointer inline-flex items-center justify-center px-4 py-2 text-sm text-white bg-primary-600 hover:bg-primary-700 rounded-md transition-colors"
            onClick={() => {
              fetchMore({
                variables: {
                  offset: data?.sites?.results?.length,
                  limit,
                  where: parseSearchParams(searchParams),
                },
              });
            }}
          >
            Charger Plus
          </button>
        </div>
      )}
    </div>
  );
};
